import React, { useEffect, useState } from 'react';
import { Button } from './Button';
import { useCountdown } from '../hooks/useCountdown';
import { Check, ShieldCheck, Lock, CreditCard, Eye, Users, Zap } from 'lucide-react';
export function OfferSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const [viewers, setViewers] = useState(47);
  useEffect(() => {
    const interval = setInterval(() => {
      setViewers(prev => {
        const change = Math.floor(Math.random() * 5) - 2;
        const next = prev + change;
        return Math.max(31, Math.min(68, next));
      });
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  const includes = [{
    name: 'MegaPack Inglese™ (5 libri)',
    isBonus: false
  }, {
    name: 'Kit di Valutazione Completo',
    isBonus: true
  }, {
    name: 'Guida alla Pronuncia Inglese',
    isBonus: true
  }, {
    name: 'Modelli di Lezione Pronti',
    isBonus: true
  }, {
    name: 'Banco degli Errori Comuni',
    isBonus: true
  }, {
    name: 'Certificati di Livello Personalizzabili',
    isBonus: true
  }, {
    name: 'Playlist Pedagogiche per ogni Unità',
    isBonus: true
  }];
  return <section id="offer" className="py-20 px-4 bg-navy-900 relative" data-id="element-83">
      <div className="max-w-5xl mx-auto" data-id="element-84">
        <div className="text-center mb-8" data-id="element-85">
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-4" data-id="element-86">
            Accedi Ora al MegaPack Inglese
          </h2>
          {/* Live viewers */}
          <div className="inline-flex items-center gap-2 bg-brand-red/10 border border-brand-red/20 text-brand-red px-4 py-2 rounded-full text-sm font-semibold" data-id="element-87">
            <Eye className="w-4 h-4" data-id="element-88" />
            <span className="relative flex h-2 w-2" data-id="element-89">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-red opacity-75" data-id="element-90"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-red" data-id="element-91"></span>
            </span>
            <span data-id="element-92">{viewers} persone stanno guardando questa offerta</span>
          </div>
        </div>

        <div className="bg-navy-800 rounded-3xl border-2 border-gold-500/50 shadow-2xl shadow-gold-500/10 overflow-hidden" data-id="element-93">
          <div className="grid lg:grid-cols-2" data-id="element-94">
            {/* Left Column - Image & Breakdown */}
            <div className="p-8 md:p-12 border-b lg:border-b-0 lg:border-r border-navy-700" data-id="element-95">
              <a href="https://pay.hotmart.com/S105109192C?checkoutMode=10" className="block cursor-pointer" data-id="element-96">
                <img src="https://cdn.magicpatterns.com/uploads/vvgYKpfnqUorGXLQbTptDN/ChatGPT_Image_Mar_27,_2026,_06_56_22_PM.png" alt="MegaPack Inglese" className="w-full h-auto rounded-xl mb-8 shadow-lg hover:shadow-gold-500/20 transition-shadow duration-300" data-id="element-97" />
              </a>

              <h3 className="text-xl font-bold text-white mb-6" data-id="element-98">
                Ecco tutto quello che ricevi oggi:
              </h3>
              <ul className="space-y-4" data-id="element-99">
                {includes.map((item, index) => <li key={index} className="flex items-center justify-between text-sm md:text-base" data-id="element-100">
                    <div className="flex items-center gap-3" data-id="element-101">
                      <Check className={`w-5 h-5 ${item.isBonus ? 'text-brand-green' : 'text-gold-400'}`} data-id="element-102" />
                      <span className={item.isBonus ? 'text-gray-300' : 'text-white font-semibold'} data-id="element-103">
                        {item.name}
                      </span>
                    </div>
                    {item.isBonus && <span className="text-brand-green font-bold uppercase text-xs bg-brand-green/10 px-2 py-1 rounded" data-id="element-104">
                        Incluso
                      </span>}
                  </li>)}
              </ul>

              <div className="mt-8 pt-6 border-t border-navy-700" data-id="element-105">
                <div className="flex items-center gap-2 text-gray-400 text-sm" data-id="element-106">
                  <Zap className="w-4 h-4 text-gold-400" data-id="element-107" />
                  <span data-id="element-108">Accesso immediato dopo il pagamento</span>
                </div>
              </div>
            </div>

            {/* Right Column - Price & CTA */}
            <div className="p-8 md:p-12 bg-gradient-to-b from-navy-800 to-navy-900 flex flex-col justify-center items-center text-center" data-id="element-109">
              <div className="bg-brand-red/10 text-brand-red border border-brand-red/20 px-4 py-2 rounded-full font-bold text-sm uppercase tracking-wider mb-6" data-id="element-110">
                Risparmi oltre il 70%!
              </div>

              <div className="mb-2" data-id="element-111">
                <span className="text-gray-400 text-lg" data-id="element-112">
                  Prezzo originale:{' '}
                  <span className="line-through" data-id="element-113">49,99 €</span>
                </span>
              </div>

              <div className="mb-4" data-id="element-114">
                <span className="text-gray-300 text-xl font-medium block mb-2" data-id="element-115">
                  Prezzo speciale oggi:
                </span>
                <div className="text-6xl md:text-7xl font-black text-white flex items-start justify-center" data-id="element-116">
                  <span className="text-3xl mt-2 mr-1" data-id="element-117">€</span>
                  15,99
                </div>
              </div>

              {/* Valore totale */}
              <div className="mb-6 bg-gold-500/10 border border-gold-500/20 rounded-lg px-4 py-2" data-id="element-118">
                <span className="text-gold-400 text-sm font-medium" data-id="element-119">
                  Valore totale del pacchetto:{' '}
                  <span className="line-through" data-id="element-120">106,94 €</span>
                </span>
              </div>

              <div className="w-full max-w-sm mb-6" data-id="element-121">
                <div className="flex justify-center items-center gap-2 text-gold-400 font-mono text-xl mb-4 bg-navy-900 py-2 rounded-lg border border-navy-700" data-id="element-122">
                  <span data-id="element-123">{hours}</span>:<span data-id="element-124">{minutes}</span>:
                  <span data-id="element-125">{seconds}</span>
                </div>
                <Button isDirectCheckout className="w-full text-2xl py-6 shadow-[0_0_40px_rgba(34,197,94,0.5)]" data-id="element-126">
                  ACQUISTA ORA
                </Button>
              </div>

              {/* Micro-commitments */}
              <p className="text-gray-500 text-xs mb-6" data-id="element-127">
                ✅ Pagamento unico · Nessun abbonamento · Accesso a vita
              </p>

              <div className="space-y-3 w-full text-left bg-navy-900/50 rounded-xl p-5 border border-navy-700" data-id="element-128">
                <div className="flex items-start gap-3" data-id="element-129">
                  <Lock className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-130" />
                  <div data-id="element-131">
                    <strong className="text-white block text-sm" data-id="element-132">
                      Transazione Sicura al 100%
                    </strong>
                    <span className="text-gray-400 text-xs" data-id="element-133">
                      Protetto con crittografia SSL a 256 bit.
                    </span>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-134">
                  <ShieldCheck className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-135" />
                  <div data-id="element-136">
                    <strong className="text-white block text-sm" data-id="element-137">
                      Garanzia 30 Giorni
                    </strong>
                    <span className="text-gray-400 text-xs" data-id="element-138">
                      Soddisfatti o rimborsati. Nessun rischio.
                    </span>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-139">
                  <CreditCard className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-140" />
                  <div data-id="element-141">
                    <strong className="text-white block text-sm" data-id="element-142">
                      Processato da Hotmart
                    </strong>
                    <span className="text-gray-400 text-xs" data-id="element-143">
                      Piattaforma leader mondiale — 35M+ utenti.
                    </span>
                  </div>
                </div>
              </div>

              {/* Payment logos inline */}
              <div className="flex flex-wrap justify-center items-center gap-2 mt-5" data-id="element-144">
                {['VISA', 'MC', 'AMEX', 'PayPal'].map((card, i) => <div key={i} className="h-7 px-3 bg-white/10 rounded text-white/60 flex items-center justify-center text-xs font-bold" data-id="element-145">
                    {card}
                  </div>)}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-146">
          <h4 className="text-2xl font-bold text-white mb-8" data-id="element-147">
            Cosa succede dopo l'acquisto?
          </h4>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-148">
            <div className="bg-navy-800 p-6 rounded-2xl border border-navy-700" data-id="element-149">
              <div className="w-12 h-12 bg-gold-500/20 text-gold-400 rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4" data-id="element-150">
                1
              </div>
              <p className="text-gray-300 font-medium" data-id="element-151">
                Completa il pagamento sicuro
              </p>
            </div>
            <div className="bg-navy-800 p-6 rounded-2xl border border-navy-700" data-id="element-152">
              <div className="w-12 h-12 bg-gold-500/20 text-gold-400 rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4" data-id="element-153">
                2
              </div>
              <p className="text-gray-300 font-medium" data-id="element-154">
                Ricevi l'email con il link di download
              </p>
            </div>
            <div className="bg-navy-800 p-6 rounded-2xl border border-navy-700" data-id="element-155">
              <div className="w-12 h-12 bg-gold-500/20 text-gold-400 rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4" data-id="element-156">
                3
              </div>
              <p className="text-gray-300 font-medium" data-id="element-157">
                Scarica e inizia subito a usare i materiali
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}